import {
  GET_CALENDAR_EVENTS,
  GET_CALENDAR_EVENTS_SUCCESS,
  GET_CALENDAR_EVENTS_FAIL,
} from "./actionTypes";

export const getCalendarEvents = clubId => ({
  type: GET_CALENDAR_EVENTS,
  payload: clubId,
});

export const getCalendarEventsSuccess = events => ({
  type: GET_CALENDAR_EVENTS_SUCCESS,
  payload: events,
});

export const getCalendarEventsFail = error => ({
  type: GET_CALENDAR_EVENTS_FAIL,
  payload: error,
});
